import { render, staticRenderFns } from "./ListLocalVotacionUsuarioTurno.vue?vue&type=template&id=28ecc599&scoped=true"
import script from "./ListLocalVotacionUsuarioTurno.vue?vue&type=script&lang=js"
export * from "./ListLocalVotacionUsuarioTurno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ecc599",
  null
  
)

export default component.exports